import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import imgDefault from '../icons/ic-face2.png';

function Arrow(props) {
  return (
    <SlideButton {...props}>
      <img
        src={
          props.isMobile
            ? 'https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-mobile-next-btn.png'
            : 'https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-next-prv.png'
        }
        alt="슬라이드 버튼"
      />
    </SlideButton>
  );
}

function ImageSlider(
  { slideList, handleSlideClick, isMobile, setSlider, syncSlider },
  ref
) {
  const sliderRef = useRef();

  useEffect(() => {
    setSlider(sliderRef.current);
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 700,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    prevArrow: <Arrow next={false} isMobile={isMobile} />,
    nextArrow: <Arrow next={true} isMobile={isMobile} />,
    beforeChange: (oldIdx, nowIdx) => {
      handleSlideClick(nowIdx);
    },
  };

  const handleChangeSlideIdx = (idx) => {
    sliderRef.current.slickGoTo(idx);
  };

  useImperativeHandle(ref, () => ({
    handleChangeSlideIdx,
  }));

  return (
    <SliderContainer>
      <Slider {...sliderSettings} ref={sliderRef} asNavFor={syncSlider}>
        {slideList.map((slide) => (
          <SlideImage
            key={slide.slideNo}
            src={slide.imageURL ?? imgDefault}
            alt="슬라이드 이미지"
          />
        ))}
      </Slider>
    </SliderContainer>
  );
}

export default forwardRef(ImageSlider);

const SliderContainer = styled.div`
  width: 100%;
  height: 100%;
  div {
    height: 100%;
  }
  .slick-prev,
  .slick-next {
    z-index: 1;
    margin: 10px;
    height: fit-content;
    :before {
      content: '';
    }
  }
  .slick-prev {
    left: 0;
  }
  .slick-next {
    right: 0;
  }
`;

const SlideImage = styled.img`
  height: 100%;
  object-fit: contain;
`;

const SlideButton = styled.button`
  img {
    transform: rotate(${(props) => (props.next ? '0' : '180deg')});
  }
`;
